module.exports = __webpack_public_path__ + "static/people_pop5-fa1cea9681f11ea45d5f3a3630682d42.png";